// Derived only from the current account's authenticated management snapshot.
// Sending is independently guarded on the server; this is an operator notice.
export function connectionAlerts(sessions = []) {
  return sessions.flatMap(session => {
    if (session.deletion || session.provisioning !== 'READY') return [];
    let message = '';
    if (session.status_error || session.status === 'UNKNOWN') {
      message = '无法确认连接状态，发送将暂停。请刷新；若持续出现，请检查账号连接。';
    } else if (session.status === 'SCAN_QR_CODE') {
      message = '登录已失效或尚未完成，请进入管理重新连接。';
    } else if (session.status === 'STOPPED') {
      message = '账号已停止，当前无法收发消息。需要使用时请进入管理启动。';
    } else if (session.status !== 'WORKING') {
      message = '账号尚未连接，当前无法收发消息。若持续未恢复，请进入管理检查连接。';
    } else if (session.integration_error ||
      (session.inbox_id && !session.messaging_enabled)) {
      message = '账号已连接，但消息转发未就绪。请进入管理核对收件箱连接。';
    }
    return message ? [{ id: session.id, name: session.name, message, session }] : [];
  });
}

export function connectionSnapshotStale(slot, now = Date.now()) {
  return Boolean(slot.data && (!slot.updatedAt || slot.error || now - slot.updatedAt > 45000));
}
